/**
 * This solves a bug. Other Teams are closing their flyouts by creating an additional click on their menu-items.
 * We need to ignore these additional Clicks. Otherwise, our flyout opens and then instantly closes.
 * @param path
 */
export function getShouldBeIgnored(path) {
    if (!Array.isArray(path)) {
        return false;
    }
    const buttons = path.filter((p) => {
        return p instanceof HTMLButtonElement;
    });
    return buttons.length === 1 ? buttons[0].className.includes('collapsed') : false;
}
